<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div mat-dialog-title>
  <!-- dialog title dependent on creating new or editing existing -->
  @if (data.article.id) {
  <span>Edit Article for Selected Teams</span>
  }
  @if (!data.article.id) {
  <span>Add Article for Selected Teams</span>
  }
  <button mat-icon-button (click)="handleEditComplete(false)" title="Cancel" class="close-button" tabindex="-1">
    <mat-icon class="mdi-24px center-self" fontIcon="mdi-close-circle-outline"></mat-icon>
  </button>
</div>
@if (!!data && data.article !== undefined && data.article !== null) {
<div mat-dialog-content>
  <div class="add-margin">
    <div>
      <mat-form-field class="full-width">
        <mat-label>Name</mat-label>
        <input type="text" matInput [formControl]="articleNameFormControl" placeholder="Name (required)"
          (blur)="saveArticle('name')" [value]="data.article.name" [errorStateMatcher]="matcher">
        @if (articleNameFormControl.hasError('required')) {
        <mat-error>
          Name is <strong>required</strong>
        </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="add-margin">
    <div>
      <mat-form-field class="full-width">
        <mat-label>Summary</mat-label>
        <input matInput placeholder="Summary (required)" [formControl]="summaryFormControl"
          (blur)="saveArticle('summary')" value="{{data.article.summary}}" [errorStateMatcher]="matcher" />
        @if (summaryFormControl.hasError('required')) {
        <mat-error>
          Summary is <strong>required</strong>
        </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  <div class="add-margin left">
    <div>
      <p style="font-size: 13px; font-weight: 400; line-height: 1.125; letter-spacing: normal;">
        Description (required) *
      </p>
      <div style="width: 21.5cm">
        <angular-editor [placeholder]="'Description'" [formControl]="descriptionFormControl"
          [config]="editorConfig"></angular-editor>
        @if (descriptionFormControl.hasError('required')) {
        <mat-error>
          Description is <strong>required</strong>
        </mat-error>
        }
      </div>
    </div>
  </div>
  <div class="add-margin">
    <div>
      <mat-form-field class="full-width">
        <mat-label>URL</mat-label>
        <input matInput placeholder="URL for more info" [formControl]="urlFormControl" (blur)="saveArticle('url')"
          value="{{data.article.url}}" />
      </mat-form-field>
    </div>
  </div>
  <div class="add-margin">
    <div class="full-width">
      <mat-checkbox [(ngModel)]="data.article.openInNewTab">
        Open URL in new tab
      </mat-checkbox>
    </div>
  </div>
  <div class="add-margin">
    <div>
      <mat-form-field>
        <mat-label>Card</mat-label>
        <mat-select placeholder="Card" [formControl]="cardIdFormControl" (selectionChange)="saveArticle('cardId')">
          @for (card of data.cardList; track card.id) {
          <mat-option [value]="card.id" [matTooltip]="card.id" matTooltipPosition="right">
            {{card.name}}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="add-margin">
    <div>
      <mat-form-field>
        <mat-label>Status</mat-label>
        <mat-select placeholder="Status" [formControl]="statusFormControl" (selectionChange)="saveArticle('status')">
          @for (itemStatusOption of itemStatusList; track itemStatusOption) {
          <mat-option [value]="itemStatusOption">
            {{ itemStatusOption }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="cssLayoutRowStartCenter bottom-button">
    <div class="delete-button">
      <button mat-stroked-button (click)="handleEditComplete(true)" [disabled]="!errorFree()"
        style="margin-left: 40px;">Save</button>
    </div>
    <div class="delete-button">
      <button mat-stroked-button (click)="handleEditComplete(false)">Cancel</button>
    </div>
  </div>
</div>
}
